export default __webpack_public_path__ + "0cc4776505bfedf29afbce5a76c494a9.svg";